/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useState, useCallback, useEffect } from "react";
import { loadWeb3, getWeb3Instance } from "./Connectivity/Connectivity";
import { toast } from "react-toastify";
import {
  USDT,
  USDTAbi,
} from "./Contract";
import "bootstrap/dist/css/bootstrap.min.css";

import { tradeXNftLpReward, tradeXNftLpRewardAbi } from "./Contract";

export default function NftReward() {
  const [btnTxt, setBtnTxt] = useState("Connect Wallet");
  const [account, setAccount] = useState("");
  const [activeTab, setActiveTab] = useState("overview");
  const [loadingStates, setLoadingStates] = useState({});
  
  // Function inputs and outputs storage
  const [functionInputs, setFunctionInputs] = useState({});
  const [functionOutputs, setFunctionOutputs] = useState({});
  
  // Overview data
  const [rewardData, setRewardData] = useState({
    globalMarketPlaceReward: "",
    globalMatrixReward: "",
    paused: false,
    usdtBalance: "",
    userUsdtBalance: ""
  });

  // ─── IMPROVED FUNCTIONS DEFINITIONS ─────────────────────────────────
  const rewardFunctions = {
    readFunctions: [
      { name: "getTradexPrice", title: "Get TradeX Price", description: "Get TradeX amount for given USDT amount", inputs: [{ name: "usdtAmount", type: "uint256", placeholder: "Enter USDT amount (wei)", required: true }], icon: "💱", category: "Price" },
      { name: "globalMarketPlaceReward", title: "Global Marketplace Reward", description: "Total accumulated marketplace reward", inputs: [], icon: "🏪", category: "Rewards" },
      { name: "globalMatrixReward", title: "Global Matrix Reward", description: "Total accumulated matrix reward", inputs: [], icon: "🤖", category: "Rewards" },
      { name: "lockDuration", title: "Lock Duration", description: "Deposit lock duration (seconds)", inputs: [], icon: "🔒", category: "Reward Settings" },
      { name: "rewardDailyPercent", title: "Reward Daily Percent", description: "Daily reward percentage", inputs: [], icon: "📊", category: "Reward Settings" },
      { name: "rewardDayDuration", title: "Reward Day Duration", description: "One day duration in seconds", inputs: [], icon: "⏱️", category: "Reward Settings" },
      { name: "rewardTotalDays", title: "Reward Total Days", description: "Total reward days", inputs: [], icon: "🗓️", category: "Reward Settings" },
      { name: "swapCount", title: "Swap Count", description: "Total swaps executed", inputs: [], icon: "🔄", category: "Stats" },
      { name: "swapThreshold", title: "Swap Threshold", description: "Minimum swap threshold", inputs: [], icon: "⚖️", category: "Stats" },
      { name: "lpReceiver", title: "LP Receiver", description: "LP receiver address", inputs: [], icon: "📤", category: "Basic Info" },
      { name: "nftMarketPlace", title: "NFT Market Place", description: "NFT marketplace address", inputs: [], icon: "🎨", category: "Basic Info" },
      { name: "nftMatrix", title: "NFT Matrix", description: "NFT matrix address", inputs: [], icon: "🤖", category: "Basic Info" },
      { name: "owner", title: "Owner", description: "Contract owner", inputs: [], icon: "👑", category: "Basic Info" },
      { name: "pair", title: "Pair", description: "Uniswap pair address", inputs: [], icon: "🔗", category: "Basic Info" },
      { name: "paused", title: "Paused", description: "Contract pause status", inputs: [], icon: "⏸️", category: "Basic Info", formatOutput: (v) => v ? "Yes (Paused)" : "No (Active)" },
      { name: "router", title: "Router", description: "Uniswap router address", inputs: [], icon: "🚀", category: "Basic Info" },
      { name: "tradexToken", title: "TradeX Token", description: "TradeX token address", inputs: [], icon: "🪐", category: "Basic Info" },
      { name: "usdtToken", title: "USDT Token", description: "USDT token address", inputs: [], icon: "💵", category: "Basic Info" },
      { name: "tradexRedeem", title: "TradeX Redeem", description: "TradeX redeem address", inputs: [], icon: "🔄", category: "Basic Info" },
      { name: "userDeposit", title: "User Deposit Info", description: "Get deposit details for any user", inputs: [{ name: "user", type: "address", placeholder: "Enter user address", required: true }], icon: "👤", category: "User Info", formatOutput: (v) => `Amount: ${v.amount || v[0]}\nTimestamp: ${new Date(Number(v.depositTimestamp || v[1]) * 1000).toLocaleString()}\nClaimed Days: ${v.claimedDays || v[2]}` },
    ],

    writeFunctions: [
      { name: "provideUSDT", title: "Provide USDT", description: "Deposit USDT to the LP reward pool", inputs: [{ name: "amount", type: "uint256", placeholder: "Enter USDT amount (wei)", required: true }], requiresUsdtApproval: true, icon: "💵", category: "Liquidity" },
      { name: "addMarketPlaceReward", title: "Add Marketplace Reward", description: "Add reward from marketplace", inputs: [{ name: "amount", type: "uint256", placeholder: "Enter amount (wei)", required: true }], requiresUsdtApproval: true, icon: "🏪", category: "Rewards" },
      { name: "addMatrixReward", title: "Add Matrix Reward", description: "Add reward from matrix", inputs: [{ name: "amount", type: "uint256", placeholder: "Enter amount (wei)", required: true }], requiresUsdtApproval: true, icon: "🤖", category: "Rewards" },
      { name: "swap", title: "Swap", description: "Trigger internal swap", inputs: [], icon: "🔄", category: "Actions" },
      { name: "swapUsdtToTradex", title: "Swap USDT to TradeX", description: "Swap accumulated USDT to TradeX", inputs: [], icon: "💱", category: "Actions" },
      { name: "setTokenApproveMax", title: "Set Token Approve Max", description: "Approve max tokens for internal use", inputs: [], icon: "✅", category: "Actions" },
      { name: "tradexMax", title: "TradeX Max Approve", description: "Max approve TradeX", inputs: [], icon: "🪐", category: "Actions" },
      { name: "usdtMax", title: "USDT Max Approve", description: "Max approve USDT", inputs: [], icon: "💵", category: "Actions" },
    ],

    adminFunctions: [
      { name: "pause", title: "Pause Contract", description: "Pause all operations", inputs: [], icon: "⏸️", category: "Control" },
      { name: "unpause", title: "Unpause Contract", description: "Resume operations", inputs: [], icon: "▶️", category: "Control" },
      { name: "renounceOwnership", title: "Renounce Ownership", description: "Permanently renounce ownership", inputs: [], icon: "🚫", category: "Ownership" },
      { name: "transferOwnership", title: "Transfer Ownership", description: "Transfer ownership to new address", inputs: [{ name: "newOwner", type: "address", placeholder: "New owner address", required: true }], icon: "🔄", category: "Ownership" },
      { name: "setLpReceiver", title: "Set LP Receiver", description: "Update LP receiver address", inputs: [{ name: "newLpReceiver", type: "address", placeholder: "New LP receiver", required: true }], icon: "📤", category: "Settings" },
      { name: "setNewNftMarketPlace", title: "Set NFT Marketplace", description: "Update NFT marketplace address", inputs: [{ name: "newNftMarketPlace", type: "address", placeholder: "New address", required: true }], icon: "🎨", category: "Settings" },
      { name: "setNftMatrixContract", title: "Set NFT Matrix", description: "Update NFT matrix address", inputs: [{ name: "newNftMatrix", type: "address", placeholder: "New address", required: true }], icon: "🤖", category: "Settings" },
      { name: "setTradexRedeem", title: "Set TradeX Redeem", description: "Update TradeX redeem address", inputs: [{ name: "newTradexRedeem", type: "address", placeholder: "New address", required: true }], icon: "🔄", category: "Settings" },
      { name: "setRouterAndPair", title: "Set Router & Pair", description: "Update router and pair", inputs: [{ name: "newRouter", type: "address", placeholder: "New router", required: true }, { name: "newPair", type: "address", placeholder: "New pair", required: true }], icon: "🔗", category: "Settings" },
      { name: "setTradexToken", title: "Set TradeX Token", description: "Update TradeX token address", inputs: [{ name: "newTradexToken", type: "address", placeholder: "New address", required: true }], icon: "🪐", category: "Settings" },
      { name: "setUsdtToken", title: "Set USDT Token", description: "Update USDT address", inputs: [{ name: "newToken", type: "address", placeholder: "New address", required: true }], icon: "💵", category: "Settings" },
      { name: "setswapThreshold", title: "Set Swap Threshold", description: "Update swap threshold", inputs: [{ name: "newswapThreshold", type: "uint256", placeholder: "New threshold (wei)", required: true }], icon: "⚖️", category: "Settings" },
      { name: "recoverErc20", title: "Recover ERC20", description: "Recover specific ERC20", inputs: [{ name: "erc20Token", type: "address", placeholder: "Token address", required: true }, { name: "amount", type: "uint256", placeholder: "Amount (wei)", required: true }], icon: "🔄", category: "Recovery" },
      { name: "recoverErc20All", title: "Recover ERC20 All", description: "Recover full balance of ERC20", inputs: [{ name: "erc20Token", type: "address", placeholder: "Token address", required: true }], icon: "♻️", category: "Recovery" },
      { name: "recoverEth", title: "Recover ETH", description: "Recover ETH", inputs: [{ name: "amount", type: "uint256", placeholder: "Amount (wei)", required: true }], icon: "💎", category: "Recovery" },
      { name: "recoverUsdt", title: "Recover USDT", description: "Recover specific USDT", inputs: [{ name: "amount", type: "uint256", placeholder: "Amount (wei)", required: true }], icon: "💵", category: "Recovery" },
      { name: "recoverUsdtAll", title: "Recover All USDT", description: "Recover full USDT balance", inputs: [], icon: "💰", category: "Recovery" },
    ]
  };

  const connectWallet = async () => {
    setLoadingStates(prev => ({ ...prev, connect: true }));
    
    try {
      const acc = await loadWeb3();
      if (acc === "No Wallet") {
        toast.error("No Wallet Detected");
        setBtnTxt("Connect Wallet");
      } else if (acc === "Wrong Network") {
        toast.error("Please switch to opBNB Mainnet");
        setBtnTxt("Wrong Network");
      } else {
        setAccount(acc);
        setBtnTxt(acc.substring(0, 6) + '...' + acc.substring(acc.length - 4));
        toast.success("Connected to opBNB Mainnet");
        loadRewardData();
      }
    } catch (error) {
      console.error("Connection error:", error);
      toast.error("Connection failed");
      setBtnTxt("Connect Wallet");
    } finally {
      setLoadingStates(prev => ({ ...prev, connect: false }));
    }
  };

  const getContract = () => {
    const web3 = getWeb3Instance();
    return new web3.eth.Contract(tradeXNftLpRewardAbi, tradeXNftLpReward);
  };

  const getUsdtContract = () => {
    const web3 = getWeb3Instance();
    return new web3.eth.Contract(USDTAbi, USDT);
  };

  const loadRewardData = useCallback(async () => {
    if (!account) return;
    try {
      const web3 = getWeb3Instance();
      const contract = getContract();
      const usdtContract = getUsdtContract();
      
      const [globalMarketPlaceReward, globalMatrixReward, paused, contractUsdtBalance, userUsdtBalance] = await Promise.all([
        contract.methods.globalMarketPlaceReward().call().catch(() => "0"),
        contract.methods.globalMatrixReward().call().catch(() => "0"),
        contract.methods.paused().call().catch(() => false),
        usdtContract.methods.balanceOf(tradeXNftLpReward).call().catch(() => "0"),
        usdtContract.methods.balanceOf(account).call().catch(() => "0")
      ]);

      setRewardData({
        globalMarketPlaceReward: parseFloat(web3.utils.fromWei(globalMarketPlaceReward.toString(), 'ether')).toFixed(2),
        globalMatrixReward: parseFloat(web3.utils.fromWei(globalMatrixReward.toString(), 'ether')).toFixed(2),
        paused: paused,
        usdtBalance: parseFloat(web3.utils.fromWei(contractUsdtBalance.toString(), 'ether')).toFixed(2),
        userUsdtBalance: parseFloat(web3.utils.fromWei(userUsdtBalance.toString(), 'ether')).toFixed(2)
      });
    } catch (error) {
      console.error("Error loading reward data:", error);
      toast.error("Failed to load reward data");
    }
  }, [account]);

  useEffect(() => {
    if (account) loadRewardData();
  }, [account, loadRewardData]);

  const handleInputChange = (functionName, inputName, value) => {
    setFunctionInputs(prev => ({
      ...prev,
      [functionName]: { ...prev[functionName], [inputName]: value }
    }));
  };

  const executeReadFunction = async (functionData) => {
    if (!account) { toast.error("Please connect your wallet first"); return; }

    const funcKey = functionData.name;
    setLoadingStates(prev => ({ ...prev, [funcKey]: true }));
    try {
      const contract = getContract();
      const inputs = functionInputs[funcKey] || {};
      
      const args = functionData.inputs.map(input => {
        const value = inputs[input.name];
        if (input.required && (!value || value.trim() === '')) {
          throw new Error(`${input.name} is required`);
        }
        return value || '';
      });

      const result = await contract.methods[functionData.name](...args).call();
      
      const formattedResult = functionData.formatOutput 
        ? functionData.formatOutput(result)
        : JSON.stringify(result, (key, value) => typeof value === 'bigint' ? value.toString() : value, 2);

      setFunctionOutputs(prev => ({ ...prev, [funcKey]: formattedResult }));
      toast.success("Read operation successful!");
    } catch (error) {
      toast.error(error.message || "Read operation failed");
    } finally {
      setLoadingStates(prev => ({ ...prev, [funcKey]: false }));
    }
  };

  const executeWriteFunction = async (functionData) => {
    if (!account) { toast.error("Please connect your wallet first"); return; }

    const funcKey = functionData.name;
    setLoadingStates(prev => ({ ...prev, [funcKey]: true }));
    try {
      const contract = getContract();
      const usdtContract = getUsdtContract();
      const inputs = functionInputs[funcKey] || {};
      
      const args = functionData.inputs.map(input => {
        const value = inputs[input.name];
        if (input.required && (!value || value.trim() === '')) {
          throw new Error(`${input.name} is required`);
        }
        return value || '';
      });

      // Approval Handling
      if (functionData.requiresUsdtApproval || functionData.requiresApproval) {
        const usdtAmount = args[0];
        const allowance = await usdtContract.methods.allowance(account, tradeXNftLpReward).call();
        if (BigInt(allowance) < BigInt(usdtAmount)) {
          toast.info("Approving USDT...");
          await usdtContract.methods.approve(tradeXNftLpReward, usdtAmount).send({ from: account });
          toast.success("USDT Approved!");
        }
      }

      const tx = await contract.methods[functionData.name](...args).send({ from: account });
      toast.success(`Transaction successful! Hash: ${tx.transactionHash}`);
      loadRewardData();
    } catch (error) {
      toast.error(error.message || "Write operation failed");
    } finally {
      setLoadingStates(prev => ({ ...prev, [funcKey]: false }));
    }
  };

  const groupFunctionsByCategory = (functions) => {
    return functions.reduce((acc, func) => {
      const cat = func.category || 'Other';
      if (!acc[cat]) acc[cat] = [];
      acc[cat].push(func);
      return acc;
    }, {});
  };

  const renderFunctionCard = (func, isWrite = false, isAdmin = false) => {
    const funcKey = func.name;
    const inputs = functionInputs[funcKey] || {};
    const output = functionOutputs[funcKey];
    const isLoading = loadingStates[funcKey] || false;

    return (
      <div key={funcKey} className="col-lg-4 col-md-6 mb-4">
        <div className="card h-100 shadow-lg border-0" style={{
          borderRadius: '20px',
          background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.02))',
          backdropFilter: 'blur(15px)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div className="card-body p-4 d-flex flex-column">
            <div className="d-flex align-items-center mb-3">
              <span className="fs-3 me-3">{func.icon}</span>
              <div>
                <h5 className="mb-1 text-white">{func.title}</h5>
                <small className="text-white-50">{func.description}</small>
              </div>
            </div>

            {func.inputs.map(input => (
              <div key={input.name} className="mb-3">
                <input
                  type="text"
                  className="form-control bg-dark border-0 text-white placeholder-white"
                  placeholder={input.placeholder}
                  value={inputs[input.name] || ''}
                  onChange={(e) => handleInputChange(funcKey, input.name, e.target.value)}
                  style={{ borderRadius: '12px', padding: '12px' }}
                />
              </div>
            ))}

            <button 
              onClick={() => isWrite || isAdmin ? executeWriteFunction(func) : executeReadFunction(func)}
              disabled={isLoading}
              className="btn w-100 mt-auto"
              style={{
                background: isWrite || isAdmin ? 'linear-gradient(135deg, #ff6b6b, #4ecdc4)' : 'linear-gradient(135deg, #00ff88, #00ccff)',
                border: 'none', color: '#fff', borderRadius: '12px', padding: '12px', fontWeight: '600'
              }}
            >
              {isLoading ? 'Processing...' : (isWrite || isAdmin ? 'Execute Write' : 'Read')}
            </button>

            {output && (
              <div className="mt-3 p-3 rounded-3" style={{
                background: 'rgba(0, 255, 136, 0.1)',
                border: '1px solid rgba(0, 255, 136, 0.3)',
                whiteSpace: 'pre-wrap',
                overflow: 'auto',
                maxHeight: '200px'
              }}>
                <small className="text-white-50 d-block mb-2">Output:</small>
                <code className="text-white">{output}</code>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center p-4" style={{
      background: 'linear-gradient(135deg, #000428, #004e92)'
    }}>
      <div className="container text-center">
        <h1 className="mb-5 display-4 fw-bold" style={{
          background: 'linear-gradient(135deg, #00ff88, #00ccff)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          TradeXNFT Reward Dashboard
        </h1>

        <div className="mb-5">
          <button 
            onClick={connectWallet}
            disabled={loadingStates.connect}
            className="btn px-4 px-md-5 py-3 rounded-pill shadow-lg position-relative overflow-hidden"
            style={{ 
              background: account ? 
                'linear-gradient(135deg, #00ff88, #00ccff)' : 
                'linear-gradient(135deg, #ff6b6b, #4ecdc4)',
              border: 'none',
              color: account ? '#000' : '#fff',
              fontSize: 'clamp(0.9rem, 3vw, 1.1rem)', 
              fontWeight: '700',
              transition: 'all 0.3s ease',
              minWidth: '160px',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
              opacity: loadingStates.connect ? 0.7 : 1
            }}
          >
            {loadingStates.connect ? (
              <div className="d-flex align-items-center">
                <div className="spinner-border spinner-border-sm me-2" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                Connecting...
              </div>
            ) : (
              <span className="position-relative">{btnTxt}</span>
            )}
          </button>
        </div>
        
        {account && (
          <div className="mt-4 p-3 rounded-4" style={{
            background: 'rgba(0, 255, 136, 0.1)',
            border: '1px solid rgba(0, 255, 136, 0.3)'
          }}>
            <div className="d-flex justify-content-center align-items-center gap-2">
              <span className="text-white-50 small">
                🔗 {account.substring(0, 6)}...{account.substring(account.length - 4)}
              </span>
              <span className="badge bg-success rounded-pill">Connected</span>
            </div>
          </div>
        )}

        {account && (
          <div className="row">
            <div className="col-12">
              <div className="card shadow-lg border-0 mb-4" style={{ 
                borderRadius: '24px',
                background: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255, 255, 255, 0.1)'
              }}>
                <div className="card-header border-0 p-4" style={{ 
                  borderRadius: '24px 24px 0 0',
                  background: 'transparent'
                }}>
                  <ul className="nav nav-pills justify-content-center flex-wrap gap-2" role="tablist">
                    {[
                      { key: 'overview', label: 'Overview', icon: '🏪', color: '#00ff88' },
                      { key: 'read', label: 'Read Functions', icon: '👁️', color: '#45b7d1' },
                      { key: 'write', label: 'Write Functions', icon: '📝', color: '#4ecdc4' },
                      { key: 'admin', label: 'Admin Functions', icon: '⚙️', color: '#ff6b6b' }
                    ].map(tab => (
                      <li key={tab.key} className="nav-item">
                        <button
                          className={`nav-link border-0 px-4 py-3 fw-bold position-relative overflow-hidden ${
                            activeTab === tab.key ? 'text-dark' : 'text-white-50'
                          }`}
                          onClick={() => setActiveTab(tab.key)}
                          style={{
                            borderRadius: '16px',
                            background: activeTab === tab.key ? 
                              `linear-gradient(135deg, ${tab.color}, ${tab.color}80)` : 
                              'rgba(255, 255, 255, 0.05)',
                            border: activeTab === tab.key ? 
                              `1px solid ${tab.color}` : 
                              '1px solid rgba(255, 255, 255, 0.1)',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            transform: activeTab === tab.key ? 'translateY(-2px)' : 'translateY(0)',
                            boxShadow: activeTab === tab.key ? 
                              `0 8px 25px ${tab.color}40` : 'none'
                          }}
                        >
                          <span className="me-2 fs-5">{tab.icon}</span>
                          <span className="d-none d-md-inline">{tab.label}</span>
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="card-body p-4" style={{
                  background: 'rgba(0, 0, 0, 0.2)',
                  borderRadius: '0 0 24px 24px'
                }}>
                  {/* Overview Tab */}
                  {activeTab === 'overview' && (
                    <div className="row g-4">
                      <div className="col-lg-3 col-md-6">
                        <div className="card h-100 border-0" style={{ 
                          borderRadius: '20px',
                          background: 'linear-gradient(135deg, rgba(0, 255, 136, 0.15), rgba(69, 183, 209, 0.1))',
                          border: '1px solid rgba(0, 255, 136, 0.3)',
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div className="card-body p-4 text-center">
                            <div className="fs-1 mb-3">💰</div>
                            <h4 className="text-white mb-2">{rewardData.globalMarketPlaceReward || '0'}</h4>
                            <p className="text-white-50 mb-0">Market Place Reward</p>
                            <button 
                              className="btn btn-sm mt-3 w-100"
                              onClick={() => executeReadFunction(rewardFunctions.readFunctions.find(f => f.name === 'globalMarketPlaceReward'))}
                              style={{
                                background: 'rgba(0, 255, 136, 0.2)',
                                border: '1px solid #00ff88',
                                color: '#00ff88'
                              }}
                            >
                              🔄 Refresh
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="card h-100 border-0" style={{ 
                          borderRadius: '20px',
                          background: 'linear-gradient(135deg, rgba(69, 183, 209, 0.15), rgba(107, 224, 215, 0.1))',
                          border: '1px solid rgba(69, 183, 209, 0.3)',
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div className="card-body p-4 text-center">
                            <div className="fs-1 mb-3">💰</div>
                            <h4 className="text-white mb-2">{rewardData.globalMatrixReward || '0'}</h4>
                            <p className="text-white-50 mb-0">Matrix Reward</p>
                            <button 
                              className="btn btn-sm mt-3 w-100"
                              onClick={() => executeReadFunction(rewardFunctions.readFunctions.find(f => f.name === 'globalMatrixReward'))}
                              style={{
                                background: 'rgba(69, 183, 209, 0.2)',
                                border: '1px solid #45b7d1',
                                color: '#45b7d1'
                              }}
                            >
                              🔄 Refresh
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="card h-100 border-0" style={{ 
                          borderRadius: '20px',
                          background: `linear-gradient(135deg, ${rewardData.paused ? 'rgba(255, 107, 107, 0.15)' : 'rgba(0, 255, 136, 0.15)'}, rgba(255, 170, 0, 0.1))`,
                          border: `1px solid ${rewardData.paused ? 'rgba(255, 107, 107, 0.3)' : 'rgba(0, 255, 136, 0.3)'}`,
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div className="card-body p-4 text-center">
                            <div className="fs-1 mb-3">{rewardData.paused ? '⏸️' : '▶️'}</div>
                            <h4 className="text-white mb-2">
                              {rewardData.paused ? 'PAUSED' : 'ACTIVE'}
                            </h4>
                            <p className="text-white-50 mb-0">Contract Status</p>
                            <button 
                              className="btn btn-sm mt-3 w-100"
                              onClick={() => executeReadFunction(rewardFunctions.readFunctions.find(f => f.name === 'paused'))}
                              style={{
                                background: rewardData.paused ? 
                                  'rgba(255, 107, 107, 0.2)' : 'rgba(0, 255, 136, 0.2)',
                                border: rewardData.paused ? 
                                  '1px solid #ff6b6b' : '1px solid #00ff88',
                                color: rewardData.paused ? '#ff6b6b' : '#00ff88'
                              }}
                            >
                              🔄 Refresh
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="card h-100 border-0" style={{ 
                          borderRadius: '20px',
                          background: 'linear-gradient(135deg, rgba(255, 170, 0, 0.15), rgba(255, 107, 107, 0.1))',
                          border: '1px solid rgba(255, 170, 0, 0.3)',
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div className="card-body p-4 text-center">
                            <div className="fs-1 mb-3">💰</div>
                            <h4 className="text-white mb-2">{rewardData.usdtBalance || '0.00'} USDT</h4>
                            <p className="text-white-50 mb-0">Contract Balance</p>
                            <button 
                              className="btn btn-sm mt-3 w-100"
                              onClick={loadRewardData}
                              style={{
                                background: 'rgba(255, 170, 0, 0.2)',
                                border: '1px solid #ffaa00',
                                color: '#ffaa00'
                              }}
                            >
                              🔄 Refresh
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="card h-100 border-0" style={{ 
                          borderRadius: '20px',
                          background: 'linear-gradient(135deg, rgba(0, 255, 136, 0.15), rgba(69, 183, 209, 0.1))',
                          border: '1px solid rgba(0, 255, 136, 0.3)',
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div className="card-body p-4 text-center">
                            <div className="fs-1 mb-3">💼</div>
                            <h4 className="text-white mb-2">{rewardData.userUsdtBalance || '0.00'} USDT</h4>
                            <p className="text-white-50 mb-0">Your Balance</p>
                            <button 
                              className="btn btn-sm mt-3 w-100"
                              onClick={loadRewardData}
                              style={{
                                background: 'rgba(0, 255, 136, 0.2)',
                                border: '1px solid #00ff88',
                                color: '#00ff88'
                              }}
                            >
                              🔄 Refresh
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Read Functions Tab */}
                  {activeTab === 'read' && (
                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h4 className="mb-0 text-info">👁️ Read Functions</h4>
                        <small className="text-white-50">
                          {rewardFunctions.readFunctions.length} functions available
                        </small>
                      </div>
                      {Object.entries(groupFunctionsByCategory(rewardFunctions.readFunctions)).map(([category, funcs]) => (
                        <div key={category} className="mb-5">
                          <h5 className="mb-3 text-white-50 d-flex align-items-center">
                            <span className="me-2">{category}</span>
                            <span className="badge bg-secondary rounded-pill">{funcs.length}</span>
                          </h5>
                          <div className="row">
                            {funcs.map(func => renderFunctionCard(func, false, false))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Write Functions Tab */}
                  {activeTab === 'write' && (
                    <div>
                      <h4 className="mb-4" style={{color: '#4ecdc4'}}>📝 Write Functions</h4>
                      {Object.entries(groupFunctionsByCategory(rewardFunctions.writeFunctions)).map(([category, funcs]) => (
                        <div key={category} className="mb-5">
                          <h5 className="mb-3 text-white-50">{category}</h5>
                          <div className="row">
                            {funcs.map(func => renderFunctionCard(func, true, false))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Admin Functions Tab */}
                  {activeTab === 'admin' && (
                    <div>
                      <h4 className="mb-4 text-danger">⚙️ Admin Functions</h4>
                      <div className="alert alert-warning">
                        <strong>⚠️ Warning:</strong> These functions are restricted to contract owner/admin only.
                      </div>
                      {Object.entries(groupFunctionsByCategory(rewardFunctions.adminFunctions)).map(([category, funcs]) => (
                        <div key={category} className="mb-5">
                          <h5 className="mb-3 text-white-50">{category}</h5>
                          <div className="row">
                            {funcs.map(func => renderFunctionCard(func, true, true))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}


///////////////////////////////////////////////////////////////////////


// /* eslint-disable no-undef */
// /* eslint-disable no-unused-vars */
// import React, { useState, useCallback, useEffect } from "react";
// import { loadWeb3, getWeb3Instance } from "./Connectivity/Connectivity";
// import { toast } from "react-toastify";
// import {
//   USDT,
//   USDTAbi,
// } from "./Contract";
// import "bootstrap/dist/css/bootstrap.min.css";

// import { tradeXNftLpReward, tradeXNftLpRewardAbi } from "./Contract";

// export default function NftReward() {
//   const [btnTxt, setBtnTxt] = useState("Connect Wallet");
//   const [account, setAccount] = useState("");
//   const [activeTab, setActiveTab] = useState("overview");
//   const [loadingStates, setLoadingStates] = useState({});
  
//   const [functionInputs, setFunctionInputs] = useState({});
//   const [functionOutputs, setFunctionOutputs] = useState({});

//   // Enhanced Overview Data
//   const [overviewData, setOverviewData] = useState({
//     globalMarketPlaceReward: "0",
//     globalMatrixReward: "0",
//     paused: false,
//     usdtBalance: "0",
//     userUsdtBalance: "0",
//     lockDuration: "0",
//     rewardDailyPercent: "0",
//     rewardDayDuration: "0",
//     rewardTotalDays: "0",
//     swapCount: "0",
//     swapThreshold: "0",
//     owner: "",
//     lpReceiver: "",
//     tradexToken: "",
//     usdtToken: "",
//     nftMarketPlace: "",
//     nftMatrix: "",
//     pair: "",
//     router: "",
//     tradexRedeem: "",
//   });

  // // ─── IMPROVED READ FUNCTIONS (20) ─────────────────────────────────
  // const readFunctions = [
  //   { name: "getTradexPrice", title: "Get TradeX Price", description: "Get TradeX amount for given USDT amount", inputs: [{ name: "usdtAmount", type: "uint256", placeholder: "Enter USDT amount (wei)" }], icon: "💱", category: "Price" },
  //   { name: "globalMarketPlaceReward", title: "Global Marketplace Reward", description: "Total accumulated marketplace reward", inputs: [], icon: "🏪", category: "Rewards" },
  //   { name: "globalMatrixReward", title: "Global Matrix Reward", description: "Total accumulated matrix reward", inputs: [], icon: "🤖", category: "Rewards" },
  //   { name: "lockDuration", title: "Lock Duration", description: "Deposit lock duration (seconds)", inputs: [], icon: "🔒", category: "Settings" },
  //   { name: "rewardDailyPercent", title: "Reward Daily Percent", description: "Daily reward percentage", inputs: [], icon: "📊", category: "Settings" },
  //   { name: "rewardDayDuration", title: "Reward Day Duration", description: "One day duration in seconds", inputs: [], icon: "⏱️", category: "Settings" },
  //   { name: "rewardTotalDays", title: "Reward Total Days", description: "Total reward days", inputs: [], icon: "🗓️", category: "Settings" },
  //   { name: "swapCount", title: "Swap Count", description: "Total swaps executed", inputs: [], icon: "🔄", category: "Stats" },
  //   { name: "swapThreshold", title: "Swap Threshold", description: "Minimum swap threshold", inputs: [], icon: "⚖️", category: "Stats" },
  //   { name: "lpReceiver", title: "LP Receiver", description: "LP receiver address", inputs: [], icon: "📤", category: "Addresses" },
  //   { name: "nftMarketPlace", title: "NFT Market Place", description: "NFT marketplace address", inputs: [], icon: "🎨", category: "Addresses" },
  //   { name: "nftMatrix", title: "NFT Matrix", description: "NFT matrix address", inputs: [], icon: "🤖", category: "Addresses" },
  //   { name: "owner", title: "Owner", description: "Contract owner", inputs: [], icon: "👑", category: "Addresses" },
  //   { name: "pair", title: "Pair", description: "Uniswap pair address", inputs: [], icon: "🔗", category: "Addresses" },
  //   { name: "paused", title: "Paused", description: "Contract pause status", inputs: [], icon: "⏸️", category: "Status", formatOutput: (v) => v ? "Yes (Paused)" : "No (Active)" },
  //   { name: "router", title: "Router", description: "Uniswap router address", inputs: [], icon: "🚀", category: "Addresses" },
  //   { name: "tradexToken", title: "TradeX Token", description: "TradeX token address", inputs: [], icon: "🪐", category: "Addresses" },
  //   { name: "usdtToken", title: "USDT Token", description: "USDT token address", inputs: [], icon: "💵", category: "Addresses" },
  //   { name: "tradexRedeem", title: "TradeX Redeem", description: "TradeX redeem address", inputs: [], icon: "🔄", category: "Addresses" },
  //   { name: "userDeposit", title: "User Deposit", description: "Get user deposit info", inputs: [{ name: "user", type: "address", placeholder: "Enter user address" }], icon: "👤", category: "User Info", formatOutput: (v) => `Amount: ${v.amount || v[0]}\nTimestamp: ${v.depositTimestamp || v[1]}\nClaimed Days: ${v.claimedDays || v[2]}` },
  // ];

  // // ─── WRITE FUNCTIONS ─────────────────────────────────
  // const writeFunctions = [
  //   { name: "provideUSDT", title: "Provide USDT", description: "Deposit USDT to LP reward pool", inputs: [{ name: "amount", type: "uint256", placeholder: "Amount in wei" }], requiresUsdtApproval: true, icon: "💵", category: "Deposit" },
  //   { name: "addMarketPlaceReward", title: "Add Marketplace Reward", description: "Add reward from marketplace", inputs: [{ name: "amount", type: "uint256", placeholder: "Amount in wei" }], requiresUsdtApproval: true, icon: "🏪", category: "Rewards" },
  //   { name: "addMatrixReward", title: "Add Matrix Reward", description: "Add reward from matrix", inputs: [{ name: "amount", type: "uint256", placeholder: "Amount in wei" }], requiresUsdtApproval: true, icon: "🤖", category: "Rewards" },
  //   { name: "swap", title: "Swap", description: "Trigger swap", inputs: [], icon: "🔄", category: "Actions" },
  //   { name: "swapUsdtToTradex", title: "Swap USDT to TradeX", description: "Swap accumulated USDT to TradeX", inputs: [], icon: "💱", category: "Actions" },
  //   { name: "setTokenApproveMax", title: "Set Token Approve Max", description: "Approve max tokens", inputs: [], icon: "✅", category: "Actions" },
  //   { name: "tradexMax", title: "TradeX Max Approve", description: "Max approve TradeX", inputs: [], icon: "🪐", category: "Actions" },
  //   { name: "usdtMax", title: "USDT Max Approve", description: "Max approve USDT", inputs: [], icon: "💵", category: "Actions" },
  // ];

  // // ─── ADMIN FUNCTIONS ─────────────────────────────────
  // const adminFunctions = [
  //   { name: "pause", title: "Pause", description: "Pause contract", inputs: [], icon: "⏸️", category: "Control" },
  //   { name: "unpause", title: "Unpause", description: "Unpause contract", inputs: [], icon: "▶️", category: "Control" },
  //   { name: "renounceOwnership", title: "Renounce Ownership", description: "Renounce ownership", inputs: [], icon: "🚫", category: "Ownership" },
  //   { name: "transferOwnership", title: "Transfer Ownership", description: "Transfer ownership", inputs: [{ name: "newOwner", type: "address", placeholder: "New owner address" }], icon: "🔄", category: "Ownership" },
  //   { name: "setLpReceiver", title: "Set LP Receiver", description: "Update LP receiver", inputs: [{ name: "newLpReceiver", type: "address" }], icon: "📤", category: "Settings" },
  //   { name: "setNewNftMarketPlace", title: "Set NFT Marketplace", description: "Update marketplace", inputs: [{ name: "newNftMarketPlace", type: "address" }], icon: "🎨", category: "Settings" },
  //   { name: "setNftMatrixContract", title: "Set NFT Matrix", description: "Update matrix contract", inputs: [{ name: "newNftMatrix", type: "address" }], icon: "🤖", category: "Settings" },
  //   { name: "setRouterAndPair", title: "Set Router & Pair", description: "Update router and pair", inputs: [{ name: "newRouter", type: "address" }, { name: "newPair", type: "address" }], icon: "🔗", category: "Settings" },
  //   { name: "setTradexRedeem", title: "Set TradeX Redeem", description: "Update redeem address", inputs: [{ name: "newTradexRedeem", type: "address" }], icon: "🔄", category: "Settings" },
  //   { name: "setTradexToken", title: "Set TradeX Token", description: "Update TradeX token", inputs: [{ name: "newTradexToken", type: "address" }], icon: "🪐", category: "Settings" },
  //   { name: "setUsdtToken", title: "Set USDT Token", description: "Update USDT token", inputs: [{ name: "newToken", type: "address" }], icon: "💵", category: "Settings" },
  //   { name: "setswapThreshold", title: "Set Swap Threshold", description: "Update swap threshold", inputs: [{ name: "newswapThreshold", type: "uint256" }], icon: "⚖️", category: "Settings" },
  //   // Recovery Functions
  //   { name: "recoverErc20", title: "Recover ERC20", description: "Recover ERC20 token", inputs: [{ name: "erc20Token", type: "address" }, { name: "amount", type: "uint256" }], icon: "🔄", category: "Recovery" },
  //   { name: "recoverErc20All", title: "Recover ERC20 All", description: "Recover all of ERC20", inputs: [{ name: "erc20Token", type: "address" }], icon: "♻️", category: "Recovery" },
  //   { name: "recoverEth", title: "Recover ETH", description: "Recover ETH", inputs: [{ name: "amount", type: "uint256" }], icon: "💎", category: "Recovery" },
  //   { name: "recoverUsdt", title: "Recover USDT", description: "Recover USDT", inputs: [{ name: "amount", type: "uint256" }], icon: "💵", category: "Recovery" },
  //   { name: "recoverUsdtAll", title: "Recover All USDT", description: "Recover all USDT", inputs: [], icon: "💰", category: "Recovery" },
  // ];

//   const getContract = () => new (getWeb3Instance().eth.Contract)(tradeXNftLpRewardAbi, tradeXNftLpReward);
//   const getUsdtContract = () => new (getWeb3Instance().eth.Contract)(USDTAbi, USDT);

//   // ─── CONNECT WALLET ─────────────────────────────────
//   const connectWallet = async () => {
//     setLoadingStates(prev => ({ ...prev, connect: true }));
//     try {
//       const acc = await loadWeb3();
//       if (acc === "No Wallet") toast.error("No Wallet Detected");
//       else if (acc === "Wrong Network") toast.error("Please switch to opBNB Mainnet");
//       else {
//         setAccount(acc);
//         setBtnTxt(acc.slice(0,6) + '...' + acc.slice(-4));
//         toast.success("Connected Successfully!");
//         loadOverviewData();
//       }
//     } catch (error) {
//       toast.error("Connection failed");
//     } finally {
//       setLoadingStates(prev => ({ ...prev, connect: false }));
//     }
//   };

//   // ─── LOAD OVERVIEW (Improved) ─────────────────────────────────
//   const loadOverviewData = useCallback(async () => {
//     if (!account) return;
//     try {
//       const contract = getContract();
//       const usdtContract = getUsdtContract();

//       const safeCall = async (method) => {
//         try { return await contract.methods[method]().call(); } 
//         catch { return "0"; }
//       };

//       const [
//         globalMarketPlaceReward, globalMatrixReward, paused,
//         usdtBalance, userUsdtBalance, lockDuration, rewardDailyPercent,
//         rewardDayDuration, rewardTotalDays, swapCount, swapThreshold,
//         owner, lpReceiver, tradexToken, usdtToken, nftMarketPlace,
//         nftMatrix, pair, router, tradexRedeem
//       ] = await Promise.all([
//         safeCall("globalMarketPlaceReward"),
//         safeCall("globalMatrixReward"),
//         safeCall("paused"),
//         usdtContract.methods.balanceOf(tradeXNftLpReward).call(),
//         usdtContract.methods.balanceOf(account).call(),
//         safeCall("lockDuration"),
//         safeCall("rewardDailyPercent"),
//         safeCall("rewardDayDuration"),
//         safeCall("rewardTotalDays"),
//         safeCall("swapCount"),
//         safeCall("swapThreshold"),
//         safeCall("owner"),
//         safeCall("lpReceiver"),
//         safeCall("tradexToken"),
//         safeCall("usdtToken"),
//         safeCall("nftMarketPlace"),
//         safeCall("nftMatrix"),
//         safeCall("pair"),
//         safeCall("router"),
//         safeCall("tradexRedeem"),
//       ]);

//       setOverviewData({
//         globalMarketPlaceReward: web3.utils.fromWei(globalMarketPlaceReward, 'ether'),
//         globalMatrixReward: web3.utils.fromWei(globalMatrixReward, 'ether'),
//         paused,
//         usdtBalance: web3.utils.fromWei(usdtBalance, 'ether'),
//         userUsdtBalance: web3.utils.fromWei(userUsdtBalance, 'ether'),
//         lockDuration: lockDuration.toString(),
//         rewardDailyPercent: rewardDailyPercent.toString(),
//         rewardDayDuration: rewardDayDuration.toString(),
//         rewardTotalDays: rewardTotalDays.toString(),
//         swapCount: swapCount.toString(),
//         swapThreshold: swapThreshold.toString(),
//         owner, lpReceiver, tradexToken, usdtToken, nftMarketPlace, nftMatrix, pair, router, tradexRedeem,
//       });
//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to load overview");
//     }
//   }, [account]);

//   useEffect(() => { if (account) loadOverviewData(); }, [account, loadOverviewData]);

//   // Input Handler
//   const handleInputChange = (funcName, inputName, value) => {
//     setFunctionInputs(prev => ({
//       ...prev,
//       [funcName]: { ...prev[funcName], [inputName]: value }
//     }));
//   };

//   // Execute Read
//   const executeReadFunction = async (func) => {
//     if (!account) return toast.error("Please connect wallet");
//     const key = func.name;
//     setLoadingStates(p => ({...p, [key]: true}));

//     try {
//       const contract = getContract();
//       const inputs = functionInputs[key] || {};
//       const args = func.inputs.map(i => inputs[i.name] || "");

//       const result = await contract.methods[func.name](...args).call();
//       const formatted = func.formatOutput ? func.formatOutput(result) : JSON.stringify(result, null, 2);

//       setFunctionOutputs(prev => ({...prev, [key]: formatted}));
//       toast.success("Read Successful");
//     } catch (e) {
//       toast.error(e.message || "Read failed");
//     } finally {
//       setLoadingStates(p => ({...p, [key]: false}));
//     }
//   };

//   // Execute Write (with improved approval)
//   const executeWriteFunction = async (func) => {
//     if (!account) return toast.error("Please connect wallet");
//     const key = func.name;
//     setLoadingStates(p => ({...p, [key]: true}));

//     try {
//       const contract = getContract();
//       const inputs = functionInputs[key] || {};
//       const args = func.inputs.map(i => inputs[i.name] || "");

//       // USDT Approval
//       if (func.requiresUsdtApproval) {
//         const amount = args[0];
//         const usdtC = getUsdtContract();
//         const allowance = await usdtC.methods.allowance(account, tradeXNftLpReward).call();

//         if (BigInt(allowance) < BigInt(amount)) {
//           toast.info("Approving USDT...");
//           await usdtC.methods.approve(tradeXNftLpReward, amount).send({ from: account });
//           toast.success("Approved!");
//         }
//       }

//       const tx = await contract.methods[func.name](...args).send({ from: account });
//       toast.success(`Transaction Successful! ${tx.transactionHash.slice(0,10)}...`);
//       loadOverviewData();
//     } catch (e) {
//       toast.error(e.message || "Transaction failed");
//     } finally {
//       setLoadingStates(p => ({...p, [key]: false}));
//     }
//   };

//   const groupByCategory = (funcs) => {
//     return funcs.reduce((acc, f) => {
//       const cat = f.category || "Other";
//       acc[cat] = acc[cat] || [];
//       acc[cat].push(f);
//       return acc;
//     }, {});
//   };

//   const renderFunctionCard = (func, isWrite = false) => {
//     const key = func.name;
//     const isLoading = loadingStates[key];

//     return (
//       <div key={key} className="col-lg-4 col-md-6 mb-4">
//         <div className="card h-100 shadow-lg border-0" style={{ borderRadius: '20px', background: 'linear-gradient(135deg, rgba(255,255,255,0.05), rgba(255,255,255,0.02))', backdropFilter: 'blur(15px)' }}>
//           <div className="card-body p-4 d-flex flex-column">
//             <div className="d-flex align-items-center mb-3">
//               <span className="fs-3 me-3">{func.icon}</span>
//               <div>
//                 <h5 className="mb-1 text-white">{func.title}</h5>
//                 <small className="text-white-50">{func.description}</small>
//               </div>
//             </div>

//             {func.inputs.map(input => (
//               <div key={input.name} className="mb-3">
//                 <input
//                   type="text"
//                   className="form-control bg-dark border-0 text-white"
//                   placeholder={input.placeholder}
//                   value={functionInputs[key]?.[input.name] || ''}
//                   onChange={(e) => handleInputChange(key, input.name, e.target.value)}
//                   style={{ borderRadius: '12px', padding: '12px' }}
//                 />
//               </div>
//             ))}

//             <button
//               onClick={() => isWrite ? executeWriteFunction(func) : executeReadFunction(func)}
//               disabled={isLoading}
//               className="btn w-100 mt-auto"
//               style={{ background: isWrite ? 'linear-gradient(135deg, #ff6b6b, #4ecdc4)' : 'linear-gradient(135deg, #00ff88, #00ccff)', color: '#fff', borderRadius: '12px', padding: '12px', fontWeight: '600' }}
//             >
//               {isLoading ? "Processing..." : (isWrite ? "Execute" : "Read")}
//             </button>

//             {functionOutputs[key] && (
//               <div className="mt-3 p-3 rounded-3 bg-dark" style={{ maxHeight: '180px', overflow: 'auto' }}>
//                 <small className="text-white-50">Output:</small>
//                 <pre className="text-white mb-0 small">{functionOutputs[key]}</pre>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center p-4" style={{ background: 'linear-gradient(135deg, #000428, #004e92)' }}>
//       <div className="container text-center">
//         <h1 className="mb-5 display-4 fw-bold" style={{ background: 'linear-gradient(135deg, #00ff88, #00ccff)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
//           TradeXNFT LP Reward Dashboard
//         </h1>

//         {/* Connect Button */}
//         <button onClick={connectWallet} disabled={loadingStates.connect} className="btn px-5 py-3 rounded-pill mb-4" style={{ background: account ? 'linear-gradient(135deg,#00ff88,#00ccff)' : 'linear-gradient(135deg,#ff6b6b,#4ecdc4)', color: account ? '#000' : '#fff', fontWeight: '700' }}>
//           {loadingStates.connect ? "Connecting..." : btnTxt}
//         </button>

//         {account && (
//           <>
//             <div className="mb-4 text-white-50">Connected: {account}</div>

//             {/* Tabs */}
//             <ul className="nav nav-pills justify-content-center mb-4">
//               {["overview", "read", "write", "admin"].map(tab => (
//                 <li key={tab} className="nav-item mx-1">
//                   <button className={`nav-link ${activeTab === tab ? 'active' : ''}`} onClick={() => setActiveTab(tab)}>
//                     {tab === 'overview' && '🏠 Overview'}
//                     {tab === 'read' && '👁️ Read Functions'}
//                     {tab === 'write' && '📝 Write Functions'}
//                     {tab === 'admin' && '⚙️ Admin'}
//                   </button>
//                 </li>
//               ))}
//             </ul>

//             {/* Overview Tab */}
//             {activeTab === 'overview' && (
//               <div className="row g-4">
//                 {/* You can expand this with more nice cards like new code if you want */}
//                 <div className="col-lg-3 col-md-6"><div className="card p-4 text-center" style={{background: 'rgba(0,255,136,0.1)'}}><h4>{overviewData.globalMarketPlaceReward}</h4><p>Market Reward</p></div></div>
//                 <div className="col-lg-3 col-md-6"><div className="card p-4 text-center" style={{background: 'rgba(69,183,209,0.1)'}}><h4>{overviewData.globalMatrixReward}</h4><p>Matrix Reward</p></div></div>
//                 <div className="col-lg-3 col-md-6"><div className="card p-4 text-center" style={{background: overviewData.paused ? 'rgba(255,107,107,0.1)' : 'rgba(0,255,136,0.1)'}}><h4>{overviewData.paused ? 'PAUSED' : 'ACTIVE'}</h4><p>Status</p></div></div>
//                 <div className="col-lg-3 col-md-6"><div className="card p-4 text-center"><h4>{overviewData.usdtBalance} USDT</h4><p>Contract Balance</p></div></div>
//               </div>
//             )}

//             {/* Read Tab */}
//             {activeTab === 'read' && Object.entries(groupByCategory(readFunctions)).map(([cat, funcs]) => (
//               <div key={cat} className="mb-5">
//                 <h4 className="text-white-50 mb-3">{cat}</h4>
//                 <div className="row">{funcs.map(f => renderFunctionCard(f))}</div>
//               </div>
//             ))}

//             {/* Write Tab */}
//             {activeTab === 'write' && Object.entries(groupByCategory(writeFunctions)).map(([cat, funcs]) => (
//               <div key={cat} className="mb-5">
//                 <h4 className="text-white-50 mb-3">{cat}</h4>
//                 <div className="row">{funcs.map(f => renderFunctionCard(f, true))}</div>
//               </div>
//             ))}

//             {/* Admin Tab */}
//             {activeTab === 'admin' && (
//               <>
//                 <div className="alert alert-warning">⚠️ Admin Only Functions</div>
//                 {Object.entries(groupByCategory(adminFunctions)).map(([cat, funcs]) => (
//                   <div key={cat} className="mb-5">
//                     <h4 className="text-white-50 mb-3">{cat}</h4>
//                     <div className="row">{funcs.map(f => renderFunctionCard(f, true))}</div>
//                   </div>
//                 ))}
//               </>
//             )}
//           </>
//         )}
//       </div>
//     </div>
//   );
// }


///////////////////////////////////////////////////////////////////////

// /* eslint-disable no-undef */
// /* eslint-disable no-unused-vars */
// import React, { useState, useCallback, useEffect } from "react";
// import { loadWeb3, getWeb3Instance } from "./Connectivity/Connectivity";
// import { toast } from "react-toastify";
// import { tradeXNftLpReward, tradeXNftLpRewardAbi } from "./Contract";
// import {
//   USDT,           // ← Add this
//   USDTAbi         // ← Add this (optional but good)
// } from "./Contract";
// import "bootstrap/dist/css/bootstrap.min.css";

// export default function NftLpReward() {
//   const [btnTxt, setBtnTxt] = useState("Connect Wallet");
//   const [account, setAccount] = useState("");
//   const [activeTab, setActiveTab] = useState("overview");
//   const [loadingStates, setLoadingStates] = useState({});
//   const [functionInputs, setFunctionInputs] = useState({});
//   const [functionOutputs, setFunctionOutputs] = useState({});

//   const [overviewData, setOverviewData] = useState({
//     paused: false,
//     globalMarketPlaceReward: "",
//     globalMatrixReward: "",
//     lockDuration: "",
//     rewardDailyPercent: "",
//     rewardDayDuration: "",
//     rewardTotalDays: "",
//     swapCount: "",
//     swapThreshold: "",
//     owner: "",
//     lpReceiver: "",
//     tradexToken: "",
//     usdtToken: "",
//     nftMarketPlace: "",
//     nftMatrix: "",
//     pair: "",
//     router: "",
//     tradexRedeem: "",
//   });

//   // ─── ALL 20 READ FUNCTIONS FROM ABI ─────────────────────────────────────
//   const readFunctions = [
//     // ── Price Helpers ──
//     {
//       name: "getTradexPrice",
//       title: "Get TradeX Price",
//       description: "Get TradeX amount for given USDT amount",
//       inputs: [{ name: "usdtAmount", type: "uint256", placeholder: "USDT amount (wei)", required: true }],
//       icon: "💱",
//       category: "Price Helpers",
//       formatOutput: (v) => `${v.toString()} wei (TradeX)`,
//     },

//     // ── Global Rewards ──
//     {
//       name: "globalMarketPlaceReward",
//       title: "Global Marketplace Reward",
//       description: "Total accumulated marketplace reward (USDT wei)",
//       inputs: [],
//       icon: "🏪",
//       category: "Global Rewards",
//       formatOutput: (v) => `${v.toString()} wei`,
//     },
//     {
//       name: "globalMatrixReward",
//       title: "Global Matrix Reward",
//       description: "Total accumulated matrix reward (USDT wei)",
//       inputs: [],
//       icon: "🤖",
//       category: "Global Rewards",
//       formatOutput: (v) => `${v.toString()} wei`,
//     },

//     // ── Reward Config ──
//     {
//       name: "lockDuration",
//       title: "Lock Duration",
//       description: "Lock period in seconds before principal can be withdrawn",
//       inputs: [],
//       icon: "🔒",
//       category: "Reward Config",
//       formatOutput: (v) => `${v.toString()} seconds`,
//     },
//     {
//       name: "rewardDailyPercent",
//       title: "Daily Reward Percent",
//       description: "Daily reward percentage for LP providers",
//       inputs: [],
//       icon: "📊",
//       category: "Reward Config",
//       formatOutput: (v) => `${v.toString()}`,
//     },
//     {
//       name: "rewardDayDuration",
//       title: "Reward Day Duration",
//       description: "Duration of one reward day in seconds",
//       inputs: [],
//       icon: "⏱️",
//       category: "Reward Config",
//       formatOutput: (v) => `${v.toString()} seconds`,
//     },
//     {
//       name: "rewardTotalDays",
//       title: "Total Reward Days",
//       description: "Total number of days rewards are distributed",
//       inputs: [],
//       icon: "📅",
//       category: "Reward Config",
//       formatOutput: (v) => `${v.toString()} days`,
//     },

//     // ── Swap Info ──
//     {
//       name: "swapCount",
//       title: "Swap Count",
//       description: "Total number of swaps executed",
//       inputs: [],
//       icon: "🔄",
//       category: "Swap Info",
//       formatOutput: (v) => `${v.toString()}`,
//     },
//     {
//       name: "swapThreshold",
//       title: "Swap Threshold",
//       description: "Minimum amount required to trigger auto-swap",
//       inputs: [],
//       icon: "⚖️",
//       category: "Swap Info",
//       formatOutput: (v) => `${v.toString()} wei`,
//     },

//     // ── Contract Addresses ──
//     {
//       name: "lpReceiver",
//       title: "LP Receiver",
//       description: "Address that receives LP tokens",
//       inputs: [],
//       icon: "💧",
//       category: "Contract Addresses",
//     },
//     {
//       name: "nftMarketPlace",
//       title: "NFT Marketplace",
//       description: "Address of the NFT marketplace contract",
//       inputs: [],
//       icon: "🛒",
//       category: "Contract Addresses",
//     },
//     {
//       name: "nftMatrix",
//       title: "NFT Matrix",
//       description: "Address of the NFT matrix contract",
//       inputs: [],
//       icon: "🤖",
//       category: "Contract Addresses",
//     },
//     {
//       name: "pair",
//       title: "Uniswap Pair",
//       description: "Address of the Uniswap V2 liquidity pair",
//       inputs: [],
//       icon: "🔗",
//       category: "Contract Addresses",
//     },
//     {
//       name: "router",
//       title: "Uniswap Router",
//       description: "Address of the Uniswap V2 router",
//       inputs: [],
//       icon: "🚀",
//       category: "Contract Addresses",
//     },
//     {
//       name: "tradexRedeem",
//       title: "TradeX Redeem",
//       description: "Address of the TradeX redeem contract",
//       inputs: [],
//       icon: "♻️",
//       category: "Contract Addresses",
//     },
//     {
//       name: "tradexToken",
//       title: "TradeX Token",
//       description: "Address of the TradeX ERC20 token",
//       inputs: [],
//       icon: "🪐",
//       category: "Contract Addresses",
//     },
//     {
//       name: "usdtToken",
//       title: "USDT Token",
//       description: "Address of the USDT ERC20 token",
//       inputs: [],
//       icon: "💵",
//       category: "Contract Addresses",
//     },

//     // ── Ownership & Status ──
//     {
//       name: "owner",
//       title: "Owner",
//       description: "Current contract owner address",
//       inputs: [],
//       icon: "👑",
//       category: "Ownership & Status",
//     },
//     {
//       name: "paused",
//       title: "Paused",
//       description: "Check whether the contract is currently paused",
//       inputs: [],
//       icon: "⏸️",
//       category: "Ownership & Status",
//       formatOutput: (v) => (v ? "Yes — Contract is PAUSED" : "No — Contract is ACTIVE"),
//     },

//     // ── User Data ──
//     {
//       name: "userDeposit",
//       title: "User Deposit Info",
//       description: "View deposit details for any address (amount, timestamp, claimed days)",
//       inputs: [{ name: "user", type: "address", placeholder: "User wallet address", required: true }],
//       icon: "👤",
//       category: "User Data",
//       formatOutput: (v) =>
//         `Amount: ${v.amount} wei\nDeposit Time: ${new Date(Number(v.depositTimestamp) * 1000).toLocaleString()}\nClaimed Days: ${v.claimedDays}`,
//     },
//   ];

//   // ─── USER WRITE FUNCTIONS (5) ────────────────────────────────────────────
//   const writeFunctions = [
//     {
//       name: "provideUSDT",
//       title: "Provide USDT",
//       description: "Deposit USDT into the LP reward pool. Auto-approval is handled.",
//       inputs: [{ name: "amount", type: "uint256", placeholder: "USDT amount (wei)", required: true }],
//       requiresUsdtApproval: true,
//       icon: "💰",
//       category: "LP Deposit",
//     },
//     {
//       name: "addMarketPlaceReward",
//       title: "Add Marketplace Reward",
//       description: "Add USDT reward from the NFT marketplace",
//       inputs: [{ name: "amount", type: "uint256", placeholder: "USDT reward amount (wei)", required: true }],
//       icon: "🏪",
//       category: "Reward Management",
//     },
//     {
//       name: "addMatrixReward",
//       title: "Add Matrix Reward",
//       description: "Add USDT reward from the NFT matrix contract",
//       inputs: [{ name: "amount", type: "uint256", placeholder: "USDT reward amount (wei)", required: true }],
//       icon: "🤖",
//       category: "Reward Management",
//     },
//     {
//       name: "swap",
//       title: "Swap",
//       description: "Trigger the internal swap mechanism",
//       inputs: [],
//       icon: "🔁",
//       category: "Swap Operations",
//     },
//     {
//       name: "swapUsdtToTradex",
//       title: "Swap USDT → TradeX",
//       description: "Manually swap USDT balance to TradeX tokens",
//       inputs: [],
//       icon: "💱",
//       category: "Swap Operations",
//     },
//   ];

//   // ─── ADMIN FUNCTIONS (21) ────────────────────────────────────────────────
//   const adminFunctions = [
//     // ── Pause Control ──
//     { name: "pause", title: "Pause Contract", description: "Pause all contract operations", inputs: [], icon: "⏸️", category: "Pause Control" },
//     { name: "unpause", title: "Unpause Contract", description: "Resume all contract operations", inputs: [], icon: "▶️", category: "Pause Control" },

//     // ── Ownership ──
//     { name: "renounceOwnership", title: "Renounce Ownership", description: "Permanently give up contract ownership", inputs: [], icon: "🚫", category: "Ownership" },
//     {
//       name: "transferOwnership",
//       title: "Transfer Ownership",
//       description: "Transfer contract ownership to a new address",
//       inputs: [{ name: "newOwner", type: "address", placeholder: "New owner address", required: true }],
//       icon: "🔄",
//       category: "Ownership",
//     },

//     // ── Admin Settings ──
//     {
//       name: "setLpReceiver",
//       title: "Set LP Receiver",
//       description: "Update the address that receives LP tokens",
//       inputs: [{ name: "newLpReceiver", type: "address", placeholder: "New LP receiver address", required: true }],
//       icon: "💧",
//       category: "Admin Settings",
//     },
//     {
//       name: "setNewNftMarketPlace",
//       title: "Set NFT Marketplace",
//       description: "Update the NFT marketplace contract address",
//       inputs: [{ name: "newNftMarketPlace", type: "address", placeholder: "New marketplace address", required: true }],
//       icon: "🛒",
//       category: "Admin Settings",
//     },
//     {
//       name: "setNftMatrixContract",
//       title: "Set NFT Matrix Contract",
//       description: "Update the NFT matrix contract address",
//       inputs: [{ name: "newNftMatrix", type: "address", placeholder: "New matrix address", required: true }],
//       icon: "🤖",
//       category: "Admin Settings",
//     },
//     {
//       name: "setRouterAndPair",
//       title: "Set Router & Pair",
//       description: "Update the Uniswap router and pair addresses",
//       inputs: [
//         { name: "newRouter", type: "address", placeholder: "New router address", required: true },
//         { name: "newPair", type: "address", placeholder: "New pair address", required: true },
//       ],
//       icon: "🚀",
//       category: "Admin Settings",
//     },
//     {
//       name: "setTradexRedeem",
//       title: "Set TradeX Redeem",
//       description: "Update the TradeX redeem contract address",
//       inputs: [{ name: "newTradexRedeem", type: "address", placeholder: "New redeem address", required: true }],
//       icon: "♻️",
//       category: "Admin Settings",
//     },
//     {
//       name: "setTradexToken",
//       title: "Set TradeX Token",
//       description: "Update the TradeX ERC20 token address",
//       inputs: [{ name: "newTradexToken", type: "address", placeholder: "New TradeX token address", required: true }],
//       icon: "🪐",
//       category: "Admin Settings",
//     },
//     {
//       name: "setUsdtToken",
//       title: "Set USDT Token",
//       description: "Update the USDT ERC20 token address",
//       inputs: [{ name: "newToken", type: "address", placeholder: "New USDT token address", required: true }],
//       icon: "💵",
//       category: "Admin Settings",
//     },
//     {
//       name: "setswapThreshold",
//       title: "Set Swap Threshold",
//       description: "Update the minimum swap threshold amount",
//       inputs: [{ name: "newswapThreshold", type: "uint256", placeholder: "New threshold (wei)", required: true }],
//       icon: "⚖️",
//       category: "Admin Settings",
//     },

//     // ── Token Max Approvals ──
//     { name: "setTokenApproveMax", title: "Set Token Approve Max", description: "Approve maximum TradeX & USDT for internal use", inputs: [], icon: "✅", category: "Token Approvals" },
//     { name: "tradexMax", title: "TradeX Max Approve", description: "Set maximum TradeX approval for router", inputs: [], icon: "🪐", category: "Token Approvals" },
//     { name: "usdtMax", title: "USDT Max Approve", description: "Set maximum USDT approval for router", inputs: [], icon: "💵", category: "Token Approvals" },

//     // ── Admin Recovery ──
//     {
//       name: "recoverErc20",
//       title: "Recover ERC20",
//       description: "Recover a specific amount of any ERC20 token stuck in contract",
//       inputs: [
//         { name: "erc20Token", type: "address", placeholder: "Token contract address", required: true },
//         { name: "amount", type: "uint256", placeholder: "Amount to recover (wei)", required: true },
//       ],
//       icon: "🔄",
//       category: "Admin Recovery",
//     },
//     {
//       name: "recoverErc20All",
//       title: "Recover All ERC20",
//       description: "Recover entire balance of any ERC20 token from contract",
//       inputs: [{ name: "erc20Token", type: "address", placeholder: "Token contract address", required: true }],
//       icon: "♻️",
//       category: "Admin Recovery",
//     },
//     {
//       name: "recoverEth",
//       title: "Recover ETH",
//       description: "Recover specific ETH amount stuck in contract",
//       inputs: [{ name: "amount", type: "uint256", placeholder: "ETH amount (wei)", required: true }],
//       icon: "⚡",
//       category: "Admin Recovery",
//     },
//     {
//       name: "recoverUsdt",
//       title: "Recover USDT",
//       description: "Recover specific USDT amount from contract",
//       inputs: [{ name: "amount", type: "uint256", placeholder: "USDT amount (wei)", required: true }],
//       icon: "💵",
//       category: "Admin Recovery",
//     },
//     { name: "recoverUsdtAll", title: "Recover All USDT", description: "Recover entire USDT balance from contract", inputs: [], icon: "💰", category: "Admin Recovery" },

//     // ── Admin Control ──
//     {
//       name: "initialize",
//       title: "Initialize",
//       description: "Initialize the contract with all core addresses (one-time setup)",
//       inputs: [
//         { name: "initialOwner", type: "address", placeholder: "Initial owner address", required: true },
//         { name: "newTradexToken", type: "address", placeholder: "TradeX token address", required: true },
//         { name: "nftMarketPlaceContract", type: "address", placeholder: "NFT marketplace address", required: true },
//         { name: "newNftMatrixContract", type: "address", placeholder: "NFT matrix address", required: true },
//         { name: "newLpReceiver", type: "address", placeholder: "LP receiver address", required: true },
//       ],
//       icon: "⚙️",
//       category: "Admin Control",
//     },
//   ];

//   // ─── ERC20 ABI for approval ───────────────────────────────────────────────
//   const ERC20_ABI = [
//     { inputs: [{ internalType: "address", name: "spender", type: "address" }, { internalType: "uint256", name: "amount", type: "uint256" }], name: "approve", outputs: [{ internalType: "bool", name: "", type: "bool" }], stateMutability: "nonpayable", type: "function" },
//     { inputs: [{ internalType: "address", name: "owner", type: "address" }, { internalType: "address", name: "spender", type: "address" }], name: "allowance", outputs: [{ internalType: "uint256", name: "", type: "uint256" }], stateMutability: "view", type: "function" },
//   ];

//   const getContract = () => {
//     const web3 = getWeb3Instance();
//     return new web3.eth.Contract(tradeXNftLpRewardAbi, tradeXNftLpReward);
//   };

//   const getTokenContract = (address) => {
//     const web3 = getWeb3Instance();
//     return new web3.eth.Contract(ERC20_ABI, address);
//   };

//   const getUsdtContract = () => {
//     const web3 = getWeb3Instance();
//     return new web3.eth.Contract(USDTAbi || ERC20_ABI, USDT);
//   };

//   // ─── CONNECT WALLET ───────────────────────────────────────────────────────
//   const connectWallet = async () => {
//     setLoadingStates((prev) => ({ ...prev, connect: true }));
//     try {
//       const acc = await loadWeb3();
//       if (acc === "No Wallet") {
//         toast.error("No Wallet Detected");
//         setBtnTxt("Connect Wallet");
//       } else if (acc === "Wrong Network") {
//         toast.error("Please switch to correct Network");
//         setBtnTxt("Wrong Network");
//       } else {
//         setAccount(acc);
//         setBtnTxt(acc.substring(0, 6) + "..." + acc.substring(acc.length - 4));
//         toast.success("Wallet Connected!");
//         loadOverviewData();
//       }
//     } catch (error) {
//       console.error("Connection error:", error);
//       toast.error("Connection failed");
//       setBtnTxt("Connect Wallet");
//     } finally {
//       setLoadingStates((prev) => ({ ...prev, connect: false }));
//     }
//   };

//   // ─── LOAD OVERVIEW DATA ───────────────────────────────────────────────────
//   const loadOverviewData = useCallback(async () => {
//     if (!account) return;
//     try {
//       const contract = getContract();
//       const safeCall = async (methodName, fallback = "0") => {
//         try {
//           if (typeof contract.methods[methodName] === "function") {
//             const res = await contract.methods[methodName]().call();
//             return res;
//           }
//           return fallback;
//         } catch (e) {
//           console.warn(`Method ${methodName} failed:`, e);
//           return fallback;
//         }
//       };

//       const [
//         paused, globalMarketReward, globalMatrixReward, lockDuration,
//         rewardDailyPct, rewardDayDur, rewardTotalDays, swapCount,
//         swapThreshold, owner, lpReceiver, tradexToken, usdtToken,
//         nftMarketPlace, nftMatrix, pair, router, tradexRedeem,
//       ] = await Promise.all([
//         safeCall("paused", false),
//         safeCall("globalMarketPlaceReward", "0"),
//         safeCall("globalMatrixReward", "0"),
//         safeCall("lockDuration", "0"),
//         safeCall("rewardDailyPercent", "0"),
//         safeCall("rewardDayDuration", "0"),
//         safeCall("rewardTotalDays", "0"),
//         safeCall("swapCount", "0"),
//         safeCall("swapThreshold", "0"),
//         safeCall("owner", ""),
//         safeCall("lpReceiver", ""),
//         safeCall("tradexToken", ""),
//         safeCall("usdtToken", ""),
//         safeCall("nftMarketPlace", ""),
//         safeCall("nftMatrix", ""),
//         safeCall("pair", ""),
//         safeCall("router", ""),
//         safeCall("tradexRedeem", ""),
//       ]);

//       setOverviewData({
//         paused,
//         globalMarketPlaceReward: globalMarketReward.toString(),
//         globalMatrixReward: globalMatrixReward.toString(),
//         lockDuration: lockDuration.toString(),
//         rewardDailyPercent: rewardDailyPct.toString(),
//         rewardDayDuration: rewardDayDur.toString(),
//         rewardTotalDays: rewardTotalDays.toString(),
//         swapCount: swapCount.toString(),
//         swapThreshold: swapThreshold.toString(),
//         owner, lpReceiver, tradexToken, usdtToken,
//         nftMarketPlace, nftMatrix, pair, router, tradexRedeem,
//       });
//     } catch (error) {
//       console.error("Error loading overview:", error);
//       toast.error("Failed to load contract data");
//     }
//   }, [account]);

//   useEffect(() => {
//     if (account) loadOverviewData();
//   }, [account, loadOverviewData]);

//   // ─── INPUT CHANGE ─────────────────────────────────────────────────────────
//   const handleInputChange = (functionName, inputName, value) => {
//     setFunctionInputs((prev) => ({
//       ...prev,
//       [functionName]: { ...prev[functionName], [inputName]: value },
//     }));
//   };

//   // ─── EXECUTE READ ─────────────────────────────────────────────────────────
//   const executeReadFunction = async (functionData) => {
//     if (!account) { toast.error("Please connect your wallet first"); return; }
//     const funcKey = functionData.name;
//     setLoadingStates((prev) => ({ ...prev, [funcKey]: true }));
//     try {
//       const contract = getContract();
//       const inputs = functionInputs[funcKey] || {};
//       const args = functionData.inputs.map((input) => {
//         const value = inputs[input.name];
//         if (input.required && (!value || value.trim() === "")) throw new Error(`${input.name} is required`);
//         return value || "";
//       });
//       const result = await contract.methods[functionData.name](...args).call();
//       const formatted = functionData.formatOutput
//         ? functionData.formatOutput(result)
//         : JSON.stringify(result, (k, v) => (typeof v === "bigint" ? v.toString() : v), 2);
//       setFunctionOutputs((prev) => ({ ...prev, [funcKey]: formatted }));
//       toast.success("Read successful!");
//     } catch (error) {
//       console.error("Read error:", error);
//       toast.error(error.message || "Read failed");
//     } finally {
//       setLoadingStates((prev) => ({ ...prev, [funcKey]: false }));
//     }
//   };

//   // ─── EXECUTE WRITE ────────────────────────────────────────────────────────
//   const executeWriteFunction = async (functionData) => {
//     if (!account) { toast.error("Please connect your wallet first"); return; }
//     const funcKey = functionData.name;
//     setLoadingStates((prev) => ({ ...prev, [funcKey]: true }));
//     try {
//       const contract = getContract();
//       const inputs = functionInputs[funcKey] || {};
//       const args = functionData.inputs.map((input) => {
//         const value = inputs[input.name];
//         if (input.required && (!value || value.trim() === "")) throw new Error(`${input.name} is required`);
//         if (input.type === "bool") return value.toLowerCase() === "true";
//         return value || "";
//       });

//       // Auto USDT approval for provideUSDT
//       if (functionData.requiresUsdtApproval) {
//         const usdtAmount = args[0];
//         let tokenContract;
        
//         if (overviewData.usdtToken && overviewData.usdtToken !== "0x0000000000000000000000000000000000000000") {
//           tokenContract = getTokenContract(overviewData.usdtToken);
//         } else {
//           tokenContract = getUsdtContract(); // fallback to imported USDT
//         }

//         try {
//           const allowance = await tokenContract.methods.allowance(account, tradeXNftLpReward).call();
//           if (BigInt(allowance) < BigInt(usdtAmount)) {
//             toast.info("Approving USDT...");
//             await tokenContract.methods.approve(tradeXNftLpReward, usdtAmount).send({ from: account });
//             toast.success("USDT Approved!");
//           }
//         } catch (approvalErr) {
//           console.error("Approval error:", approvalErr);
//           toast.error("Approval failed");
//           throw approvalErr;
//         }
//       }

//       const tx = await contract.methods[functionData.name](...args).send({ from: account });
//       toast.success(`✅ Tx: ${tx.transactionHash.substring(0, 18)}...`);
//       loadOverviewData();
//     } catch (error) {
//       console.error("Write error:", error);
//       toast.error(error.message || "Transaction failed");
//     } finally {
//       setLoadingStates((prev) => ({ ...prev, [funcKey]: false }));
//     }
//   };

//   // ─── GROUP BY CATEGORY ────────────────────────────────────────────────────
//   const groupByCategory = (functions) =>
//     functions.reduce((acc, func) => {
//       const cat = func.category || "Other";
//       if (!acc[cat]) acc[cat] = [];
//       acc[cat].push(func);
//       return acc;
//     }, {});

//   // ─── RENDER FUNCTION CARD ─────────────────────────────────────────────────
//   const renderFunctionCard = (func, isWrite = false) => {
//     const funcKey = func.name;
//     const inputs = functionInputs[funcKey] || {};
//     const output = functionOutputs[funcKey];
//     const isLoading = loadingStates[funcKey] || false;
//     const btnGradient = isWrite
//       ? "linear-gradient(135deg, #ff6b6b, #4ecdc4)"
//       : "linear-gradient(135deg, #00ff88, #00ccff)";

//     return (
//       <div key={funcKey} className="col-lg-4 col-md-6 mb-4">
//         <div
//           className="card h-100 shadow-lg border-0"
//           style={{
//             borderRadius: "20px",
//             background: "linear-gradient(135deg, rgba(255,255,255,0.05), rgba(255,255,255,0.02))",
//             backdropFilter: "blur(15px)",
//             border: "1px solid rgba(255,255,255,0.1)",
//           }}
//         >
//           <div className="card-body p-4 d-flex flex-column">
//             <div className="d-flex align-items-center mb-3">
//               <span className="fs-3 me-3">{func.icon}</span>
//               <div>
//                 <h6 className="mb-1 text-white fw-bold" style={{ fontSize: "0.9rem" }}>{func.title}</h6>
//                 <small className="text-white-50" style={{ fontSize: "0.75rem" }}>{func.description}</small>
//               </div>
//             </div>

//             {func.inputs.map((input) => (
//               <div key={input.name} className="mb-2">
//                 <input
//                   type="text"
//                   className="form-control bg-dark border-0 text-white custom-placeholder"
//                   placeholder={input.placeholder}
//                   value={inputs[input.name] || ""}
//                   onChange={(e) => handleInputChange(funcKey, input.name, e.target.value)}
//                   style={{ borderRadius: "12px", padding: "10px 14px", fontSize: "0.85rem" }}
//                 />
//               </div>
//             ))}

//             <button
//               onClick={() => (isWrite ? executeWriteFunction(func) : executeReadFunction(func))}
//               disabled={isLoading}
//               className="btn w-100 mt-auto"
//               style={{
//                 background: isLoading ? "rgba(255,255,255,0.1)" : btnGradient,
//                 border: "none",
//                 color: "#fff",
//                 borderRadius: "12px",
//                 padding: "11px",
//                 fontWeight: "600",
//                 fontSize: "0.9rem",
//                 transition: "opacity 0.2s",
//               }}
//             >
//               {isLoading ? (
//                 <span>
//                   <span className="spinner-border spinner-border-sm me-2" role="status" />
//                   Processing...
//                 </span>
//               ) : isWrite ? (
//                 "⚡ Execute"
//               ) : (
//                 "🔍 Read"
//               )}
//             </button>

//             {output !== undefined && output !== null && output !== "" && (
//               <div
//                 className="mt-3 p-3 rounded-3"
//                 style={{
//                   background: "rgba(0,255,136,0.08)",
//                   border: "1px solid rgba(0,255,136,0.25)",
//                   maxHeight: "180px",
//                   overflowY: "auto",
//                 }}
//               >
//                 <small className="text-white-50 d-block mb-1">Output:</small>
//                 <code className="text-white" style={{ fontSize: "0.82rem", wordBreak: "break-all", whiteSpace: "pre-wrap" }}>
//                   {output}
//                 </code>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // ─── TABS ─────────────────────────────────────────────────────────────────
//   const tabs = [
//     { key: "overview", label: "Overview", icon: "🏪", color: "#00ff88" },
//     { key: "read",     label: "Read (20)",  icon: "👁️", color: "#45b7d1" },
//     { key: "write",    label: "Write (5)",  icon: "📝", color: "#4ecdc4" },
//     { key: "admin",    label: "Admin (21)", icon: "⚙️", color: "#ff6b6b" },
//   ];

//   // ─── OVERVIEW STAT CARDS ──────────────────────────────────────────────────
//   const overviewStatCards = [
//     { label: "Status",          value: overviewData.paused ? "PAUSED" : "ACTIVE", icon: overviewData.paused ? "⏸️" : "▶️", color: overviewData.paused ? "#ff6b6b" : "#00ff88" },
//     { label: "Market Reward",   value: overviewData.globalMarketPlaceReward || "—", icon: "🏪", color: "#f7d774" },
//     { label: "Matrix Reward",   value: overviewData.globalMatrixReward || "—",      icon: "🤖", color: "#4ecdc4" },
//     { label: "Daily %",         value: overviewData.rewardDailyPercent || "—",      icon: "📊", color: "#45b7d1" },
//     { label: "Total Days",      value: overviewData.rewardTotalDays || "—",         icon: "📅", color: "#a78bfa" },
//     { label: "Swap Count",      value: overviewData.swapCount || "—",              icon: "🔄", color: "#f97316" },
//     { label: "Lock Duration",   value: overviewData.lockDuration ? `${overviewData.lockDuration}s` : "—", icon: "🔒", color: "#22d3ee" },
//     { label: "Swap Threshold",  value: overviewData.swapThreshold || "—",          icon: "⚖️", color: "#84cc16" },
//   ];

//   const overviewAddresses = [
//     { label: "Owner",          value: overviewData.owner },
//     { label: "LP Receiver",    value: overviewData.lpReceiver },
//     { label: "TradeX Token",   value: overviewData.tradexToken },
//     { label: "USDT Token",     value: overviewData.usdtToken },
//     { label: "NFT Marketplace",value: overviewData.nftMarketPlace },
//     { label: "NFT Matrix",     value: overviewData.nftMatrix },
//     { label: "Uniswap Pair",   value: overviewData.pair },
//     { label: "Router",         value: overviewData.router },
//     { label: "TradeX Redeem",  value: overviewData.tradexRedeem },
//   ];

//   // ─── RENDER ───────────────────────────────────────────────────────────────
//   return (
//     <div
//       className="container-fluid min-vh-100 d-flex align-items-center justify-content-center p-4"
//       style={{ background: "linear-gradient(135deg, #000428, #004e92)" }}
//     >
//       <style>{`
//         .custom-placeholder::placeholder { color: rgba(255,255,255,0.6) !important; }
//         .fn-badge { font-size: 0.7rem; padding: 2px 8px; border-radius: 20px; background: rgba(255,255,255,0.12); color: #fff; margin-left: 6px; }
//       `}</style>

//       <div className="container text-center">
//         {/* ── HEADER ── */}
//         <h1
//           className="mb-2 display-5 fw-bold"
//           style={{ background: "linear-gradient(135deg, #00ff88, #00ccff)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}
//         >
//           TradeX LP Reward Dashboard
//         </h1>
//         <p className="text-white-50 mb-4">TradeX LP Reward Contract Interface · 20 Read · 26 Write</p>

//         {/* ── CONNECT BUTTON ── */}
//         <div className="mb-4">
//           <button
//             onClick={connectWallet}
//             disabled={loadingStates.connect}
//             className="btn px-5 py-3 rounded-pill shadow-lg"
//             style={{
//               background: account ? "linear-gradient(135deg,#00ff88,#00ccff)" : "linear-gradient(135deg,#ff6b6b,#4ecdc4)",
//               border: "none",
//               color: account ? "#000" : "#fff",
//               fontSize: "clamp(0.9rem,3vw,1.1rem)",
//               fontWeight: "700",
//               minWidth: "160px",
//               opacity: loadingStates.connect ? 0.7 : 1,
//             }}
//           >
//             {loadingStates.connect ? (
//               <span className="d-flex align-items-center gap-2">
//                 <span className="spinner-border spinner-border-sm" /> Connecting...
//               </span>
//             ) : (
//               btnTxt
//             )}
//           </button>
//         </div>

//         {account && (
//           <div
//             className="d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill mb-4"
//             style={{ background: "rgba(0,255,136,0.1)", border: "1px solid rgba(0,255,136,0.3)" }}
//           >
//             <span className="text-white-50 small">🔗 {account.substring(0, 6)}...{account.substring(account.length - 4)}</span>
//             <span className="badge bg-success rounded-pill">Connected</span>
//           </div>
//         )}

//         {/* ── MAIN CARD ── */}
//         {account && (
//           <div
//             className="card shadow-lg border-0"
//             style={{
//               borderRadius: "24px",
//               background: "rgba(255,255,255,0.05)",
//               backdropFilter: "blur(20px)",
//               border: "1px solid rgba(255,255,255,0.1)",
//             }}
//           >
//             {/* TAB BAR */}
//             <div className="card-header border-0 p-4" style={{ borderRadius: "24px 24px 0 0", background: "transparent" }}>
//               <ul className="nav nav-pills justify-content-center flex-wrap gap-2">
//                 {tabs.map((tab) => (
//                   <li key={tab.key} className="nav-item">
//                     <button
//                       className={`nav-link border-0 px-4 py-2 fw-bold ${activeTab === tab.key ? "text-dark" : "text-white-50"}`}
//                       onClick={() => setActiveTab(tab.key)}
//                       style={{
//                         borderRadius: "14px",
//                         background: activeTab === tab.key ? `linear-gradient(135deg,${tab.color},${tab.color}80)` : "rgba(255,255,255,0.05)",
//                         border: activeTab === tab.key ? `1px solid ${tab.color}` : "1px solid rgba(255,255,255,0.1)",
//                         transition: "all 0.3s ease",
//                         transform: activeTab === tab.key ? "translateY(-2px)" : "none",
//                         boxShadow: activeTab === tab.key ? `0 6px 20px ${tab.color}40` : "none",
//                       }}
//                     >
//                       <span className="me-1">{tab.icon}</span>
//                       <span className="d-none d-sm-inline">{tab.label}</span>
//                     </button>
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             {/* TAB CONTENT */}
//             <div className="card-body p-4" style={{ background: "rgba(0,0,0,0.2)", borderRadius: "0 0 24px 24px" }}>

//               {/* ── OVERVIEW TAB ── */}
//               {activeTab === "overview" && (
//                 <div>
//                   {/* Stat Cards */}
//                   <div className="row g-3 mb-4">
//                     {overviewStatCards.map((card) => (
//                       <div key={card.label} className="col-lg-3 col-md-4 col-6">
//                         <div
//                           className="card border-0 h-100"
//                           style={{
//                             borderRadius: "18px",
//                             background: `linear-gradient(135deg,${card.color}20,${card.color}08)`,
//                             border: `1px solid ${card.color}40`,
//                           }}
//                         >
//                           <div className="card-body p-3 text-center">
//                             <div className="fs-2 mb-2">{card.icon}</div>
//                             <h5 className="fw-bold mb-1 text-truncate" style={{ color: card.color, fontSize: "1rem" }} title={card.value}>
//                               {card.value}
//                             </h5>
//                             <p className="text-white-50 mb-0" style={{ fontSize: "0.7rem" }}>{card.label}</p>
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>

//                   {/* Address Section */}
//                   <div
//                     className="p-3 rounded-4 text-start"
//                     style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)" }}
//                   >
//                     <h6 className="text-white-50 mb-3">📋 Contract Addresses</h6>
//                     <div className="row g-2">
//                       {overviewAddresses.map((item) => (
//                         <div key={item.label} className="col-md-4">
//                           <div className="p-2 rounded-3" style={{ background: "rgba(0,0,0,0.3)" }}>
//                             <small className="text-white-50 d-block">{item.label}</small>
//                             <code className="text-info" style={{ fontSize: "0.72rem", wordBreak: "break-all" }}>
//                               {item.value || "Loading..."}
//                             </code>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                     <div className="mt-3 text-end">
//                       <button
//                         className="btn btn-sm"
//                         onClick={loadOverviewData}
//                         style={{ background: "rgba(0,255,136,0.15)", border: "1px solid #00ff88", color: "#00ff88", borderRadius: "10px" }}
//                       >
//                         🔄 Refresh All
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* ── READ TAB (20 functions) ── */}
//               {activeTab === "read" && (
//                 <div>
//                   <div className="d-flex justify-content-between align-items-center mb-4">
//                     <h5 className="mb-0 text-info">👁️ Read Functions</h5>
//                     <small className="text-white-50">{readFunctions.length} functions</small>
//                   </div>
//                   {Object.entries(groupByCategory(readFunctions)).map(([category, funcs]) => (
//                     <div key={category} className="mb-5">
//                       <h6 className="mb-3 d-flex align-items-center gap-2 text-white-50">
//                         {category}
//                         <span className="badge bg-secondary">{funcs.length}</span>
//                       </h6>
//                       <div className="row">{funcs.map((func) => renderFunctionCard(func, false))}</div>
//                     </div>
//                   ))}
//                 </div>
//               )}

//               {/* ── WRITE TAB (5 user functions) ── */}
//               {activeTab === "write" && (
//                 <div>
//                   <div className="d-flex justify-content-between align-items-center mb-4">
//                     <h5 className="mb-0" style={{ color: "#4ecdc4" }}>📝 Write Functions</h5>
//                     <small className="text-white-50">{writeFunctions.length} functions</small>
//                   </div>
//                   {Object.entries(groupByCategory(writeFunctions)).map(([category, funcs]) => (
//                     <div key={category} className="mb-5">
//                       <h6 className="mb-3 d-flex align-items-center gap-2 text-white-50">
//                         {category}
//                         <span className="badge bg-secondary">{funcs.length}</span>
//                       </h6>
//                       <div className="row">{funcs.map((func) => renderFunctionCard(func, true))}</div>
//                     </div>
//                   ))}
//                 </div>
//               )}

//               {/* ── ADMIN TAB (21 functions) ── */}
//               {activeTab === "admin" && (
//                 <div>
//                   <div className="d-flex justify-content-between align-items-center mb-3">
//                     <h5 className="mb-0 text-danger">⚙️ Admin Functions</h5>
//                     <small className="text-white-50">{adminFunctions.length} functions</small>
//                   </div>
//                   <div
//                     className="alert mb-4 text-start"
//                     style={{
//                       background: "rgba(255,107,107,0.1)",
//                       border: "1px solid rgba(255,107,107,0.4)",
//                       borderRadius: "14px",
//                       color: "#ffaaaa",
//                     }}
//                   >
//                     <strong>⚠️ Warning:</strong> These functions are restricted to the contract owner only.
//                   </div>
//                   {Object.entries(groupByCategory(adminFunctions)).map(([category, funcs]) => (
//                     <div key={category} className="mb-5">
//                       <h6 className="mb-3 d-flex align-items-center gap-2 text-white-50">
//                         {category}
//                         <span className="badge bg-secondary">{funcs.length}</span>
//                       </h6>
//                       <div className="row">{funcs.map((func) => renderFunctionCard(func, true))}</div>
//                     </div>
//                   ))}
//                 </div>
//               )}

//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }